import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardActions, CardMedia, CardContent, Typography } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(theme => ({
  cardActions: {
    padding: 0,
    backgroundColor: theme.palette.primary.main,
    justifyContent: 'center'
  },
  listenButton: {
    margin: 0,
    color: "white",
    height: "72px",
    width: "100%"
  },
  listenIcon: {
    height: "20px",
    width: "32px"
  },
  link: {
    textDecoration: "none"
  }
}));

function Sermon(props) {
  const { sermon, formatDate, selectAudio, showArchiveLink } = props;
  const classes = useStyles();
  
  let archiveLink;
  if (showArchiveLink)
    archiveLink = <CardActions>
                    <Link to="/sermons" className={classes.link}>
                      <Button color="primary" to="/sermons">
                        Go to Sermon Archive
                      </Button>
                    </Link>
                  </CardActions>;

  return (
    <Card>
      <CardMedia
        component="img"
        alt={sermon.title}
        image={sermon.itunes.image}
        title={sermon.title}
      />
      <CardContent>
        <Typography variant="h6" component="p">
          {sermon.title}
        </Typography>
        <Typography hidden={!sermon.itunes.subtitle} variant="body2" component="p">
          {sermon.itunes.subtitle}
        </Typography>
        <Typography variant="body1" component="p">
          {formatDate(sermon.pubDate)}
        </Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button className={classes.listenButton} onClick={() => selectAudio(sermon)}>
          Listen
          <OpenInNewIcon className={classes.listenIcon} />
        </Button>
      </CardActions>
      {archiveLink}
    </Card>
  );
}
export default Sermon;